// Modalidades de una guía. Una misma guía (mismo guideId) puede tener la
// gratuita, la de pago, o las dos: desde VIVA-312 las variantes viven bajo el
// mismo guideId y ya NO como dos guías distintas con sufijo "-PAID" en el
// código. El catálogo devuelve una sola fila por guía con hasFreeVariant y
// hasPaidVariant, y el detalle una fila por variante activa.
export const GUIDE_VARIANTS = {
  FREE: "FREE",
  PAID: "PAID",
};

export const isGuideVariant = (value) =>
  value === GUIDE_VARIANTS.FREE || value === GUIDE_VARIANTS.PAID;
